import {
	GET_DAYS_OFF,
	GET_DAYS_OFF_ERROR,
	GET_DAYS_OFF_SUCCESS,
} from '../../../constants';

export const getHolidaysReducer = (state, actions) => {
	switch (actions.type) {
		case GET_DAYS_OFF:
			return {
				...state,
				loading: true,
				error: null,
				errorShow: false,
				holidays: null
			};
		case GET_DAYS_OFF_ERROR:
			return {
				...state,
				loading: false,
				error: actions.payload,
				errorShow: true,
			};
		case GET_DAYS_OFF_SUCCESS:
			return {
				...state,
				loading: false,
				error: null,
				errorShow: false,
				holidays: actions.payload,
			};
		default:
			return state;
	}
};
